export default "__VITE_ASSET__c39378c4__"